import { useTranslation } from 'react-i18next'
import { FieldArray, useFormikContext } from 'formik'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import InputAdornment from '@mui/material/InputAdornment'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import TextField from '@/components/formik/fields/TextField'

import { CreateMeetingLinkFormValues } from '../CreateMeetingLinkForm'

type WizardSpecialitiesStepProps = {
  SpecialitiesSelection: React.ReactElement
}

export default function WizardSpecialitiesStep(props: WizardSpecialitiesStepProps) {
  const { SpecialitiesSelection } = props
  const { t } = useTranslation()
  const { values } = useFormikContext<CreateMeetingLinkFormValues>()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {SpecialitiesSelection}
      </Grid>
      <Grid item xs={12}>
        <FieldArray name="specialities">
          {() => (
            <Stack divider={<Divider />} spacing={2}>
              {values.specialities.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                  {t('page.createMeetingLink.wizard.specialities.empty')}
                </Typography>
              )}
              {values.specialities.map((speciality, index) => (
                <Stack key={speciality.code || index} direction="row" alignItems="center" justifyContent="space-between">
                  <Typography variant="body1">{speciality.name}</Typography>
                  <Box sx={{ width: 160 }}>
                    <TextField
                      InputProps={{ endAdornment: <InputAdornment position="start">€</InputAdornment> }}
                      name={`specialities[${index}].price`}
                      placeholder={t('field.price.label')}
                      type="number"
                      size="small"
                    />
                  </Box>
                </Stack>
              ))}
            </Stack>
          )}
        </FieldArray>
      </Grid>
    </Grid>
  )
}
